import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateServiceQuality = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 436,
	height: 406,
	viewBox: "0 0 436 406",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M222.274 405.13C325.971 405.13 410.033 321.068 410.033 217.372C410.033 113.676 325.971 29.6138 222.274 29.6138C118.578 29.6138 34.5161 113.676 34.5161 217.372C34.5161 321.068 118.578 405.13 222.274 405.13Z",
			fill: "#EBF3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M279.308 114.341V90.4372C279.308 71.9313 294.311 56.9287 312.817 56.9287H314.86H97.1515C78.6456 56.9287 63.6431 71.9313 63.6431 90.4372V344.168C63.6431 349.723 68.1448 354.225 73.7002 354.225H269.473C274.908 354.225 279.308 349.816 279.308 344.39V109.747",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M314.851 56.9287C334.105 56.9287 349.746 72.5691 349.746 91.8237V186.378H279.956V91.8237C279.956 72.5691 295.596 56.9287 314.851 56.9287Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			opacity: .8,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M314.851 56.9287C334.105 56.9287 349.746 72.5691 349.746 91.8237V186.378H279.956V91.8237C279.956 72.5691 295.596 56.9287 314.851 56.9287Z",
				fill: "#DCEBFE"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M317.272 354.234L341.065 341.136C343.552 339.768 346.584 341.589 346.556 344.417L346.26 370.827C346.233 373.646 343.182 375.393 340.733 374.007L317.235 360.705C314.712 359.281 314.739 355.639 317.272 354.243V354.234Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M263.409 1.24463L272.746 17.4766C273.698 19.122 272.515 21.1833 270.61 21.2018L252.409 21.3405C250.514 21.359 249.304 19.3346 250.209 17.6707L259.074 1.30009C259.999 -0.409999 262.439 -0.43773 263.409 1.24463Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.096 164.202L3.864 154.866C2.21862 153.914 0.157269 155.097 0.138781 157.001L0.000125704 175.202C-0.0183617 177.097 2.00601 178.308 3.66988 177.402L20.0405 168.537C21.7506 167.613 21.7783 165.173 20.096 164.202Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M422.494 267.076L413.157 283.308C412.205 284.953 413.388 287.014 415.293 287.033L433.494 287.172C435.389 287.19 436.599 285.166 435.694 283.502L426.829 267.131C425.904 265.421 423.464 265.393 422.494 267.076Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M383.134 163.25H349.746V186.378H383.134V163.25Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M383.134 163.25H349.746V186.378H383.134V163.25Z",
				fill: "#DCEBFE"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M279.309 109.747V344.39C279.309 349.825 274.899 354.225 269.473 354.225H73.6914C68.136 354.225 63.6343 349.723 63.6343 344.168V90.4372C63.6343 71.9313 78.6368 56.9287 97.1427 56.9287H312.808",
			stroke: "#6BA6FF",
			strokeWidth: 9.29,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M347.629 109.137H417.419V151.307C417.419 170.562 401.779 186.202 382.524 186.202C363.269 186.202 347.629 170.562 347.629 151.307V109.137Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M279.308 114.341V90.4372C279.308 71.9313 294.311 56.9287 312.817 56.9287H314.859",
			stroke: "#6BA6FF",
			strokeWidth: 9.29,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M348.359 153.664V90.4372C348.359 71.9313 333.357 56.9287 314.851 56.9287",
			stroke: "#6BA6FF",
			strokeWidth: 9.29,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M348.359 128.799V152.703C348.359 171.209 363.361 186.212 381.867 186.212H383.91",
			stroke: "#6BA6FF",
			strokeWidth: 9.29,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M417.419 109.137V152.694C417.419 171.2 402.416 186.202 383.91 186.202",
			stroke: "#6BA6FF",
			strokeWidth: 9.29,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M241.816 108.046H101.127C94.3522 108.046 88.8604 113.538 88.8604 120.313V149.634C88.8604 156.408 94.3522 161.9 101.127 161.9H241.816C248.591 161.9 254.083 156.408 254.083 149.634V120.313C254.083 113.538 248.591 108.046 241.816 108.046Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.909 153.303C130.033 153.303 138.24 145.096 138.24 134.973C138.24 124.849 130.033 116.643 119.909 116.643C109.786 116.643 101.579 124.849 101.579 134.973C101.579 145.096 109.786 153.303 119.909 153.303Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.54 127.246H230.742",
			stroke: "#9EC5FF",
			strokeWidth: 5.31,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.54 142.71H205.765",
			stroke: "#9EC5FF",
			strokeWidth: 5.31,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.294 128.909C117.645 129.261 117.996 129.603 118.338 129.954C118.948 130.573 118.948 131.294 118.338 131.904C117.904 132.348 117.469 132.782 117.016 133.217C116.896 133.328 116.887 133.42 116.952 133.568C117.248 134.271 117.673 134.899 118.144 135.482C119.106 136.656 120.187 137.709 121.481 138.514C121.759 138.689 122.064 138.809 122.35 138.966C122.498 139.05 122.6 139.022 122.72 138.902C123.154 138.449 123.607 138.005 124.051 137.571C124.633 136.988 125.373 136.988 125.955 137.571C126.676 138.282 127.388 138.994 128.1 139.715C128.701 140.316 128.691 141.046 128.1 141.656C127.693 142.063 127.268 142.451 126.88 142.886C126.325 143.505 125.622 143.708 124.818 143.672C123.653 143.607 122.581 143.219 121.546 142.719C119.244 141.601 117.285 140.057 115.639 138.098C114.428 136.656 113.421 135.075 112.764 133.3C112.441 132.44 112.219 131.562 112.284 130.629C112.33 130.056 112.543 129.566 112.968 129.159C113.421 128.724 113.855 128.271 114.308 127.828C114.89 127.255 115.63 127.255 116.212 127.828C116.573 128.188 116.933 128.549 117.294 128.909Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M241.816 187.357H101.126C94.3517 187.357 88.8599 192.849 88.8599 199.624V228.945C88.8599 235.719 94.3517 241.211 101.126 241.211H241.816C248.59 241.211 254.082 235.719 254.082 228.945V199.624C254.082 192.849 248.59 187.357 241.816 187.357Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.909 232.615C130.032 232.615 138.239 224.408 138.239 214.284C138.239 204.161 130.032 195.954 119.909 195.954C109.785 195.954 101.579 204.161 101.579 214.284C101.579 224.408 109.785 232.615 119.909 232.615Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.54 206.557H230.741",
			stroke: "#9EC5FF",
			strokeWidth: 5.31,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.54 222.021H205.765",
			stroke: "#9EC5FF",
			strokeWidth: 5.31,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.293 208.22C117.645 208.572 117.996 208.914 118.338 209.265C118.948 209.884 118.948 210.605 118.338 211.215C117.903 211.659 117.469 212.093 117.016 212.528C116.896 212.639 116.887 212.731 116.951 212.879C117.247 213.582 117.672 214.21 118.144 214.793C119.105 215.967 120.187 217.02 121.481 217.825C121.758 218 122.063 218.12 122.35 218.277C122.498 218.361 122.599 218.333 122.719 218.213C123.154 217.76 123.607 217.316 124.05 216.882C124.633 216.299 125.372 216.299 125.955 216.882C126.676 217.593 127.387 218.305 128.099 219.026C128.7 219.627 128.691 220.357 128.099 220.967C127.692 221.374 127.267 221.762 126.879 222.197C126.324 222.816 125.622 223.02 124.818 222.983C123.653 222.918 122.581 222.53 121.545 222.03C119.244 220.912 117.284 219.368 115.639 217.409C114.428 215.967 113.42 214.386 112.764 212.611C112.44 211.751 112.219 210.873 112.283 209.94C112.329 209.367 112.542 208.877 112.967 208.47C113.42 208.035 113.855 207.583 114.308 207.139C114.89 206.566 115.629 206.566 116.212 207.139C116.572 207.499 116.933 207.86 117.293 208.22Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M241.816 268.351H101.127C94.3522 268.351 88.8604 273.843 88.8604 280.617V309.939C88.8604 316.713 94.3522 322.205 101.127 322.205H241.816C248.591 322.205 254.083 316.713 254.083 309.939V280.617C254.083 273.843 248.591 268.351 241.816 268.351Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.91 315.374C131.008 315.374 140.006 306.377 140.006 295.278C140.006 284.18 131.008 275.183 119.91 275.183C108.811 275.183 99.814 284.18 99.814 295.278C99.814 306.377 108.811 315.374 119.91 315.374Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.909 313.608C130.033 313.608 138.24 305.402 138.24 295.278C138.24 285.155 130.033 276.948 119.909 276.948C109.786 276.948 101.579 285.155 101.579 295.278C101.579 305.402 109.786 313.608 119.909 313.608Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.54 287.55H230.742",
			stroke: "#9EC5FF",
			strokeWidth: 5.31,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.54 303.015H205.765",
			stroke: "#9EC5FF",
			strokeWidth: 5.31,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.525 289.75C117.839 290.065 118.163 290.388 118.477 290.703C119.031 291.266 119.041 291.923 118.477 292.487C118.079 292.884 117.682 293.291 117.275 293.688C117.164 293.79 117.155 293.873 117.21 294.012C117.478 294.65 117.867 295.223 118.301 295.759C119.179 296.831 120.159 297.783 121.342 298.523C121.592 298.68 121.878 298.8 122.137 298.939C122.276 299.013 122.368 298.985 122.47 298.874C122.868 298.458 123.274 298.061 123.681 297.654C124.217 297.127 124.883 297.127 125.419 297.654C126.075 298.301 126.722 298.957 127.369 299.604C127.915 300.15 127.905 300.824 127.369 301.37C126.999 301.74 126.611 302.1 126.26 302.488C125.752 303.061 125.114 303.237 124.384 303.2C123.32 303.145 122.341 302.793 121.398 302.331C119.299 301.314 117.515 299.9 116.009 298.116C114.899 296.794 113.984 295.361 113.384 293.744C113.088 292.958 112.884 292.154 112.949 291.303C112.986 290.776 113.189 290.333 113.568 289.963C113.984 289.566 114.382 289.15 114.789 288.752C115.325 288.225 115.99 288.225 116.526 288.752C116.859 289.076 117.183 289.408 117.506 289.732L117.525 289.75Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M285.927 307.304C315.026 307.304 338.616 283.714 338.616 254.615C338.616 225.516 315.026 201.926 285.927 201.926C256.828 201.926 233.238 225.516 233.238 254.615C233.238 283.714 256.828 307.304 285.927 307.304Z",
			fill: "#6BA6FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M276.84 235.314C277.857 236.331 278.874 237.348 279.89 238.365C281.675 240.167 281.675 242.265 279.9 244.05C278.624 245.334 277.358 246.619 276.054 247.876C275.712 248.209 275.685 248.477 275.86 248.902C276.711 250.955 277.949 252.766 279.336 254.476C282.127 257.906 285.289 260.956 289.051 263.313C289.855 263.822 290.752 264.192 291.593 264.645C292.027 264.876 292.323 264.802 292.665 264.45C293.941 263.138 295.244 261.853 296.538 260.559C298.239 258.876 300.375 258.867 302.085 260.559C304.174 262.629 306.254 264.709 308.324 266.798C310.062 268.545 310.043 270.69 308.296 272.455C307.113 273.648 305.865 274.776 304.756 276.024C303.129 277.845 301.096 278.427 298.757 278.298C295.364 278.113 292.24 276.985 289.227 275.524C282.534 272.271 276.812 267.76 272.024 262.066C268.484 257.85 265.563 253.266 263.64 248.089C262.706 245.584 262.041 243.023 262.244 240.306C262.374 238.633 263.002 237.209 264.232 236.035C265.553 234.778 266.82 233.447 268.123 232.162C269.833 230.48 271.969 230.489 273.679 232.162C274.732 233.197 275.777 234.251 276.822 235.305L276.84 235.314Z",
			fill: "#EBF3FF"
		})
	]
});
export default SvgEmptyStateServiceQuality;
